import { useTranslation } from 'react-i18next';
import { useDeleteInvitationSource } from './deleteInvitationSourcePanel/utility/useDeleteInvitationSource';
import { ConfirmationPrompt } from '../../../../../../components/ConfirmationPrompt';

const DeleteInvitationSourcePanel = ({
  hearingId,
  selectedGroupName,
  setSelectedGroupName,
}) => {
  const { t: translator } = useTranslation();
  const {
    isPopupOpen,
    isUpdating,
    setIsPopupOpen,
    onConfirm,
  } = useDeleteInvitationSource(
    hearingId,
    selectedGroupName,
    setSelectedGroupName,
  );

  return (
    <ConfirmationPrompt
      isOpen={isPopupOpen}
      onDismiss={setIsPopupOpen}
      onConfirm={onConfirm}
      text={translator(
        'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourcePanel.prompt',
      )}
      disabled={isUpdating}
    />
  );
};

export { DeleteInvitationSourcePanel };
